import React, { Fragment } from "react";

import CardItem from "./CardItem";

const IndustryPositionItem = ({
  episode: { currentepisode, recentepisode },
}) => {
  return (
    <Fragment>
      {currentepisode && currentepisode.jobpositions
        ? currentepisode.jobpositions.map((jobposition) => (
            <CardItem key={jobposition._id} jobposition={jobposition} />
          ))
        : null}
    </Fragment>
  );
};

export default IndustryPositionItem;
